var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmTrixChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 71.75V14.875C49 12.327 48.993 10.675 48.832 9.464C48.678 8.3265 48.4295 7.9695 48.23 7.77C48.0305 7.5705 47.6735 7.322 46.536 7.168C45.3215 7.007 43.673 7 41.125 7C38.577 7 36.925 7.007 35.714 7.168C34.5765 7.322 34.2195 7.5705 34.02 7.77C33.8205 7.9695 33.572 8.3265 33.418 9.464C33.257 10.6785 33.25 12.327 33.25 14.875V71.75H49Z",
    fill: "url(#paint0_linear_184_437)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M28 30.625C28 29.9288 27.7234 29.2611 27.2312 28.7688C26.7389 28.2766 26.0712 28 25.375 28H14.875C14.1788 28 13.5111 28.2766 13.0188 28.7688C12.5266 29.2611 12.25 29.9288 12.25 30.625V71.75H28V30.625ZM70 48.125C70 47.4288 69.7234 46.7611 69.2312 46.2688C68.7389 45.7766 68.0712 45.5 67.375 45.5H56.875C56.1788 45.5 55.5111 45.7766 55.0188 46.2688C54.5266 46.7611 54.25 47.4288 54.25 48.125V71.75H70V48.125Z",
    fill: "#4095D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.125 71.75C5.42881 71.75 4.76113 72.0266 4.26884 72.5188C3.77656 73.0111 3.5 73.6788 3.5 74.375C3.5 75.0712 3.77656 75.7389 4.26884 76.2312C4.76113 76.7234 5.42881 77 6.125 77H76.125C76.8212 77 77.4889 76.7234 77.9812 76.2312C78.4734 75.7389 78.75 75.0712 78.75 74.375C78.75 73.6788 78.4734 73.0111 77.9812 72.5188C77.4889 72.0266 76.8212 71.75 76.125 71.75H6.125Z",
    fill: "#007AFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_437",
    x1: 33.25,
    y1: 39.375,
    x2: 49,
    y2: 39.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18487F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C4F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmTrixChart);
export default __webpack_public_path__ + "static/media/Pharm Trix Chart.df24763ce8c898fa87092a0b9849a1bd.svg";
export { ForwardRef as ReactComponent };